import { render, staticRenderFns } from "./_ObjectLayoutSidebar.vue?vue&type=template&id=b7a613d2&"
import script from "./_ObjectLayoutSidebar.vue?vue&type=script&lang=ts&"
export * from "./_ObjectLayoutSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./_ObjectLayoutSidebar.vue?vue&type=style&index=0&id=b7a613d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports